"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ClipboardCheck, ClipboardList, Plane, Sparkles } from "lucide-react";
export default function OurServicesOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const services = [{
    id: 1,
    icon: ClipboardCheck,
    title: "Inspección",
    tagline: "Evaluación aérea inicial completa"
  }, {
    id: 2,
    icon: ClipboardList,
    title: "Planificación",
    tagline: "Definimos parámetros de ejecución"
  }, {
    id: 3,
    icon: Plane,
    title: "Ejecución",
    tagline: "Limpieza con drones avanzados"
  }, {
    id: 4,
    icon: Sparkles,
    title: "Limpieza",
    tagline: "Resultados inmediatos visibles"
  }];
  return <section className="bg-light-background py-16 px-6">
      <div className="mx-auto max-w-7xl">
        

        <div ref={mapRef} className={`mt-8 transition-all duration-[250ms] ${mapVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          <h2 className="mb-8 text-center font-display text-3xl font-bold text-secondary">
            Nuestra cobertura
          </h2>
          <div className="mx-auto w-full overflow-hidden rounded-xl shadow-medium">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8158463.243447547!2d-77.28111935!3d5.5289149!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e15a43aae1594a3%3A0x9a0d9a04eff2a340!2sColombia!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s" width="100%" height="450" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Mapa de cobertura - Bogotá, Medellín, Cartagena, Barranquilla" />
          </div>
        </div>
      </div>
    </section>;
}